// ==================================
// Pagina de Reportes
// ==================================

import { Header } from '@/componentes/layout';
import { Card, CardHeader } from '@/componentes/ui';

export function Reportes() {
  const reportes = [
    {
      titulo: 'Reporte de Ingresos',
      descripcion: 'MRR, ARR, ingresos por mes y churn rate',
      icono: (
        <svg
          className="w-8 h-8 text-emerald-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      color: 'bg-emerald-100',
    },
    {
      titulo: 'Reporte de Veterinarias',
      descripcion: 'Análisis de crecimiento y retención',
      icono: (
        <svg
          className="w-8 h-8 text-primary-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
      ),
      color: 'bg-primary-100',
    },
    {
      titulo: 'Reporte de Uso',
      descripcion: 'Métricas de uso de la plataforma',
      icono: (
        <svg
          className="w-8 h-8 text-gold-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
      ),
      color: 'bg-gold-100',
    },
  ];

  return (
    <div>
      <Header titulo="Reportes" />

      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reportes.map((reporte) => (
            <Card
              key={reporte.titulo}
              className="cursor-pointer hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${reporte.color}`}>
                  {reporte.icono}
                </div>
                <div>
                  <h3 className="font-semibold text-obsidian-900">
                    {reporte.titulo}
                  </h3>
                  <p className="text-sm text-stone-500 mt-1">
                    {reporte.descripcion}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <Card className="mt-8">
          <CardHeader
            title="Próximos reportes"
            subtitle="Funcionalidad en desarrollo"
          />
          <p className="text-stone-500">
            Los reportes detallados con gráficas interactivas estarán
            disponibles próximamente. Por ahora puedes ver las estadísticas
            generales en el Dashboard.
          </p>
        </Card>
      </div>
    </div>
  );
}

export default Reportes;
